import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { LanguageToggle } from '../components/ui/LanguageToggle';
export function Disclaimer() {
  const {
    lang
  } = useLanguage();
  const content = lang === 'es' ? <>
        <h1 data-id="element-381">Aviso Médico</h1>
        <p className="muted" data-id="element-382">Última actualización: 29 de mayo de 2026</p>

        <h2 data-id="element-383">Información general</h2>
        <p data-id="element-384">
          El contenido de lipolaserbeverlyhills.com tiene fines exclusivamente
          informativos y educativos. No constituye asesoramiento médico,
          diagnóstico ni recomendación de tratamiento. Todo procedimiento es
          realizado y supervisado por el Dr. Naveed N. Nosrati MD.
        </p>

        <h2 data-id="element-385">No es una relación médico-paciente</h2>
        <p data-id="element-386">
          Acceder a este sitio o solicitar una consulta privada NO establece una
          relación médico-paciente. Dicha relación solo se establece tras una
          consulta presencial formal con el especialista.
        </p>

        <h2 data-id="element-387">Resultados individuales</h2>
        <p data-id="element-388">
          Los resultados estéticos varían significativamente entre cada
          paciente. Factores que influyen incluyen:
        </p>
        <ul data-id="element-389">
          <li data-id="element-390">Anatomía individual y composición corporal</li>
          <li data-id="element-391">Edad y elasticidad de la piel</li>
          <li data-id="element-392">Estilo de vida y hábitos alimenticios</li>
          <li data-id="element-393">Cumplimiento del protocolo post-procedimiento</li>
          <li data-id="element-394">Salud general y condiciones preexistentes</li>
        </ul>
        <p data-id="element-395">
          Las imágenes mostradas representan casos reales con consentimiento
          expreso. NO son garantía de resultados similares para cada paciente.
        </p>

        <h2 data-id="element-396">Lipolaser y procedimientos estéticos</h2>
        <p data-id="element-397">
          El Lipolaser es un procedimiento estético no quirúrgico para contorno
          corporal. NO es un tratamiento para la obesidad ni un sustituto de
          dieta y ejercicio. Su candidatura debe ser evaluada individualmente
          por un profesional médico calificado.
        </p>

        <h2 data-id="element-398">Riesgos y consideraciones</h2>
        <p data-id="element-399">
          Como con cualquier procedimiento estético, existen riesgos potenciales
          que serán discutidos detalladamente durante su consulta privada. Es
          responsabilidad del paciente proporcionar información médica completa
          y precisa al equipo clínico.
        </p>

        <h2 data-id="element-400">Cumplimiento regulatorio</h2>
        <p data-id="element-401">
          Lipo Laser · Dermaclinic Beverly Hills opera bajo las normas y
          regulaciones del Estado de California y cumple con HIPAA en el manejo
          de información médica protegida.
        </p>

        <h2 data-id="element-402">Búsqueda de atención médica</h2>
        <p data-id="element-403">
          Si está considerando un procedimiento estético, consulte siempre con
          un profesional médico certificado. No retrase la búsqueda de atención
          médica basándose únicamente en información encontrada en internet.
        </p>

        <h2 data-id="element-404">Contacto</h2>
        <p data-id="element-405">
          Para consultas médicas específicas, solicite su consulta privada o
          contáctenos en{' '}
          <a href="mailto:hello@lipolaserbeverlyhills.com" data-id="element-406">
            hello@lipolaserbeverlyhills.com
          </a>
        </p>
      </> : <>
        <h1 data-id="element-407">Medical Disclaimer</h1>
        <p className="muted" data-id="element-408">Last updated: May 29, 2026</p>

        <h2 data-id="element-409">General information</h2>
        <p data-id="element-410">
          The content of lipolaserbeverlyhills.com is for informational and
          educational purposes only. It does not constitute medical advice,
          diagnosis, or treatment recommendation. All procedures are performed
          and supervised by Dr. Naveed N. Nosrati MD.
        </p>

        <h2 data-id="element-411">No physician-patient relationship</h2>
        <p data-id="element-412">
          Accessing this site or requesting a private consultation does NOT
          establish a physician-patient relationship. Such relationship is only
          established after a formal in-person consultation with the specialist.
        </p>

        <h2 data-id="element-413">Individual results</h2>
        <p data-id="element-414">
          Aesthetic results vary significantly between each patient. Factors
          that influence outcomes include:
        </p>
        <ul data-id="element-415">
          <li data-id="element-416">Individual anatomy and body composition</li>
          <li data-id="element-417">Age and skin elasticity</li>
          <li data-id="element-418">Lifestyle and eating habits</li>
          <li data-id="element-419">Adherence to post-procedure protocol</li>
          <li data-id="element-420">General health and pre-existing conditions</li>
        </ul>
        <p data-id="element-421">
          Images shown represent real cases with express consent. They are NOT a
          guarantee of similar results for every patient.
        </p>

        <h2 data-id="element-422">Lipolaser and aesthetic procedures</h2>
        <p data-id="element-423">
          Lipolaser is a non-surgical aesthetic procedure for body contouring.
          It is NOT a treatment for obesity nor a substitute for diet and
          exercise. Your candidacy must be individually evaluated by a qualified
          medical professional.
        </p>

        <h2 data-id="element-424">Risks and considerations</h2>
        <p data-id="element-425">
          As with any aesthetic procedure, there are potential risks that will
          be discussed in detail during your private consultation. It is the
          patient's responsibility to provide complete and accurate medical
          information to the clinical team.
        </p>

        <h2 data-id="element-426">Regulatory compliance</h2>
        <p data-id="element-427">
          Lipo Laser · Dermaclinic Beverly Hills operates under the rules and
          regulations of the State of California and complies with HIPAA in the
          handling of protected health information.
        </p>

        <h2 data-id="element-428">Seeking medical care</h2>
        <p data-id="element-429">
          If you are considering an aesthetic procedure, always consult with a
          certified medical professional. Do not delay seeking medical care
          based solely on information found on the internet.
        </p>

        <h2 data-id="element-430">Contact</h2>
        <p data-id="element-431">
          For specific medical inquiries, request your private consultation or
          contact us at{' '}
          <a href="mailto:hello@lipolaserbeverlyhills.com" data-id="element-432">
            hello@lipolaserbeverlyhills.com
          </a>
        </p>
      </>;
  return <LegalLayout data-id="element-433">{content}</LegalLayout>;
}
function LegalLayout({
  children
}: {
  children: React.ReactNode;
}) {
  return <main className="min-h-screen bg-brand-cream" data-id="element-434">
      <header className="border-b border-brand-stone/50 py-6" data-id="element-435">
        <div className="container mx-auto px-6 flex items-center justify-between" data-id="element-436">
          <Link to="/" className="flex items-baseline gap-1.5" data-id="element-437">
            <span className="text-2xl font-serif font-normal text-brand-dark" data-id="element-438">
              Lipo Laser
            </span>
            <span className="text-[10px] font-medium tracking-[0.2em] uppercase text-brand-gold" data-id="element-439">
              Beverly Hills
            </span>
          </Link>
          <LanguageToggle data-id="element-440" />
        </div>
      </header>

      <article className="container mx-auto px-6 py-20 max-w-3xl legal-content" data-id="element-441">
        {children}
        <div className="mt-16 pt-8 border-t border-brand-stone/50" data-id="element-442">
          <Link to="/" className="text-[11px] font-medium tracking-widest uppercase text-brand-dark/60 hover:text-brand-dark transition-colors" data-id="element-443">
            ← Home
          </Link>
        </div>
      </article>

      <style data-id="element-444">{`
        .legal-content h1 {
          font-family: 'Playfair Display', serif;
          font-weight: 300;
          font-size: 3rem;
          color: #1B1714;
          letter-spacing: -0.02em;
          margin-bottom: 0.5rem;
        }
        .legal-content h2 {
          font-family: 'Playfair Display', serif;
          font-weight: 400;
          font-size: 1.5rem;
          color: #1B1714;
          margin-top: 2.5rem;
          margin-bottom: 0.75rem;
        }
        .legal-content p, .legal-content li {
          color: rgba(27, 23, 20, 0.75);
          line-height: 1.7;
          font-weight: 300;
          margin-bottom: 0.75rem;
        }
        .legal-content ul {
          list-style: none;
          padding-left: 1rem;
        }
        .legal-content li {
          padding-left: 1.5rem;
          position: relative;
        }
        .legal-content li::before {
          content: '·';
          color: #C9A961;
          position: absolute;
          left: 0;
          font-weight: 700;
        }
        .legal-content a {
          color: #C97B63;
          text-decoration: underline;
          text-underline-offset: 3px;
        }
        .legal-content a:hover {
          color: #1B1714;
        }
        .legal-content .muted {
          color: rgba(27, 23, 20, 0.4);
          font-size: 0.875rem;
          font-weight: 500;
          letter-spacing: 0.05em;
          margin-bottom: 3rem;
        }
        .legal-content strong {
          color: #1B1714;
          font-weight: 500;
        }
      `}</style>
    </main>;
}